import React, { Fragment } from 'react';
import { translate } from '../Services/translation';

const sameCategory = (item, index, array) =>
    (index > 0 && array[index - 1].category === array[index].category) ||
    item.showAll;

const QuickSearchResult = ({ result, selectedItem, searchUrl, searchQuery }) => (
    <ul className="quick-search-result">
        {result && result.length > 0 ?
            result.map((item, index, array) => (
                <Fragment key={`${item.name}-${index}`}>
                    {item.category === 'NoHit' ||
                        sameCategory(item, index, array) ? null : (
                        <li className="quick-search-result__group-header">
                            {item.category} <span>({result.length - 1})</span>
                        </li>
                    )}
                    {item.category !== 'NoHit' ?

                        <li
                            className={`quick-search-result__item ${selectedItem === index
                                ? 'quick-search-result__item--selected'
                                : ''
                                }`}
                        >
                            {!item.showAll && item.category !== 'NoHit' && <span className='quick-search-result__pages-icon'></span>}
                            <a
                                className={
                                    item.showAll
                                        ? 'quick-search-result__show-all'
                                        : `quick-search-result__link ${item.url
                                            ? ''
                                            : 'quick-search-result__link--disabled'
                                        }`
                                }
                                href={item.showAll ? searchUrl : item.url}
                            >
                                {item.hasImage && item.imageSource && (
                                    <img
                                        className="quick-search-result__image"
                                        src={item.imageSource}
                                    />
                                )}
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: item.name.toLowerCase().replace(searchQuery, '<b>' + searchQuery + '</b>'),
                                    }}
                                ></div>
                            </a>
                        </li>
                        :
                        <li className='quick-search-result__noHit'>
                            <p>{translate('general.search.window.nohit.title')}</p>
                            <h4>"{searchQuery}"</h4>
                            <div className='quick-search-result__noHit-error'>
                                {/*  <p>{translate('general.search.window.nohit.subtitle.left')}<span> "{searchQuery}" </span>{translate('general.search.window.nohit.subtitle.right')}</p> */}
                                <p>{translate('general.search.window.nohit.subtitle')} "<b>{searchQuery}</b>" </p>
                            </div>
                            <div>

                            </div>
                        </li>
                    }
                </Fragment>
            ))
            :
            <li className='quick-search-result__empty'>
                <span></span>
                <h4>{translate('general.search.window.title')}</h4>
                <p>{translate('general.search.window.subtitle')}</p>
            </li>
        }
    </ul>
);

export default QuickSearchResult;
